import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { BhApi, Empty } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type ICreate = GRpcRequestType<BhApi.ActionsPlanBhGrpcContractClient['Create']>;
export type IGetSubstances = GRpcRequestType<BhApi.ActionsPlanBhGrpcContractClient['GetSubstances']>;
export type IGetAvailableSubstances = GRpcRequestType<BhApi.ActionsPlanBhGrpcContractClient['GetAvailableSubstances']>;
export type IReplaceSubstances = GRpcRequestType<BhApi.ActionsPlanBhGrpcContractClient['ReplaceSubstances']>;

@Injectable()
export class ActionsPlanBhGrpcContractService extends GrpcCommonService<BhApi.ActionsPlanBhGrpcContractClient> {
  constructor(protected _GrpcContract: BhApi.ActionsPlanBhGrpcContractClient) {
    super();
  }

  create(request: ICreate) {
    return from(this._GrpcContract.Create(new BhApi.WebRequest_Guid(request), this.getMetadata())).pipe(grpcOperator());
  }

  getLast() {
    return from(this._GrpcContract.GetLast(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }

  getSubstances(request: IGetSubstances) {
    return from(this._GrpcContract.GetSubstances(new BhApi.WebRequest_Guid(request), this.getMetadata())).pipe(
      grpcOperator(),
    );
  }

  getAvailableSubstances(request: IGetAvailableSubstances) {
    return from(this._GrpcContract.GetAvailableSubstances(new BhApi.WebRequest_Guid(request), this.getMetadata())).pipe(
      grpcOperator(),
    );
  }

  replaceSubstances(request: IReplaceSubstances) {
    return from(
      this._GrpcContract.ReplaceSubstances(new BhApi.ReplacePlanSubstancesWpcRequest(request), this.getMetadata()),
    ).pipe(grpcOperator());
  }
}
